/**
 * ActionButton — Standard button variants.
 * primary: solid navy, secondary: outlined, danger: red, success: green
 */
import React from 'react';

interface ActionButtonProps {
  label: string;
  onClick: (e: React.MouseEvent) => void;
  variant?: 'primary' | 'secondary' | 'danger' | 'success' | 'ghost';
  size?: 'sm' | 'md';
  disabled?: boolean;
  title?: string;
}

const VARIANTS: Record<string, React.CSSProperties> = {
  primary: { background: '#1e3a5f', color: '#fff', border: 'none' },
  secondary: { background: '#ffffff', color: 'var(--text-secondary)', border: '1px solid var(--border-default)' },
  danger: { background: '#ef4444', color: '#fff', border: 'none' },
  success: { background: '#16a34a', color: '#fff', border: 'none' },
  ghost: { background: 'transparent', color: 'var(--text-secondary)', border: 'none' },
};

const SIZES: Record<string, React.CSSProperties> = {
  sm: { padding: '4px 12px', fontSize: 11 },
  md: { padding: '8px 18px', fontSize: 13 },
};

export default function ActionButton({ label, onClick, variant = 'primary', size = 'md', disabled, title }: ActionButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={title}
      style={{
        ...VARIANTS[variant],
        ...SIZES[size],
        borderRadius: 6, fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.15s', opacity: disabled ? 0.5 : 1,
        fontFamily: 'var(--font-sans)',
      }}
    >
      {label}
    </button>
  );
}
